import { SafeHtml, Skeleton } from '@thg-commerce/gravity-elements'
import { AccordionTitle } from '@thg-commerce/gravity-system'
import { mq, spacing, styled, Text } from '@thg-commerce/gravity-theme'

export const ProductContentSafeHTML = styled(SafeHtml)`
  margin: ${spacing(1)} ${spacing(1)} ${spacing(3)};
  p {
    ${Text('bodyText', 'default')};
    margin-bottom: ${spacing(2)};
  }
  strong {
    ${Text('bodyText', 'alternate')};
  }
  h2 {
    ${Text('medium1', 'alternate')};
  }
  h3 {
    ${Text('bodyText', 'alternate')};
  }
  em {
    font-style: italic;
  }
  table {
    margin-top: ${spacing(1)};
  }
`

export const StyledAccordionTitle = styled(AccordionTitle)`
  text-align: left;
`

export const ProductDescriptionContentWrapper = styled.div`
  flex-basis: 100%;
  flex-direction: column;
  padding: ${spacing(1)};
`

export const ProductDetailContainer = styled.div`
  display: block;
  width: 100%;

  &:nth-child(odd) {
    background-color: ${(props) => props.theme.colors.palette.greys.lighter};
  }

  ${({ theme }) => mq(theme.breakpointUtils.map, 'sm')} {
    display: flex;
    flex-direction: row;
  }
`

export const ProductDetailKey = styled.p`
  display: flex;
  align-items: center;
  flex-basis: 25%;
  padding: ${spacing(1)} ${spacing(2)};
  ${Text('bodyText', 'alternate')};
`

export const ProductDetailSafeHTML = styled(SafeHtml)`
  display: flex;
  align-items: center;
  flex-basis: 75%;
  flex-grow: 1;
  padding: ${spacing(1)} ${spacing(1)} ${spacing(1)} ${spacing(2)};

  p {
    ${Text('bodyText', 'default')};
  }
  strong {
    ${Text('bodyText', 'alternate')};
  }
  h2 {
    ${Text('large2', 'alternate')};
  }
  h3 {
    ${Text('large1', 'alternate')};
  }
`

export const SkeletonAccordion = styled(Skeleton)`
  height: 27px;
  margin: ${spacing(0.25)};
`

export const Title = styled.h2<{ hasBottomPadding: boolean }>`
  ${Text('medium1', 'alternate')};
  ${(props) => props.hasBottomPadding && `padding-bottom: ${spacing(3)};`}
`

export const SubTitle = styled.p`
  ${Text('bodyText', 'default')};
  padding-bottom: ${spacing(3)};
`
